import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IProducts } from '../models/products.model';

export const currentProductsForSomeoneElseFeatureKey = 'currentProductsForSomeoneElse';

export interface CurrentProductsForSomeoneElseState {
  loadCurrentProductsForSomeoneElseResponse: IProducts[];
  loadCurrentProductsForSomeoneElseFailure: Error | any;
}

export const initialState: CurrentProductsForSomeoneElseState = {
  loadCurrentProductsForSomeoneElseResponse: undefined,
  loadCurrentProductsForSomeoneElseFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadCurrentProductsForSomeoneElse, (state, action) => ({
    ...state
  })),
  on(actions.loadCurrentProductsForSomeoneElseSuccess, (state, action) => ({
    ...state,
    loadCurrentProductsForSomeoneElseResponse: action.response
  })),
  on(actions.loadCurrentProductsForSomeoneElseFailure, (state, action) => ({
    ...state,
    loadCurrentProductsForSomeoneElseFailure: action.error
  }))
);

export const getCurrentProductsForSomeoneElseResponse = (state: CurrentProductsForSomeoneElseState) =>
  state.loadCurrentProductsForSomeoneElseResponse;
